import { mapMutations, mapActions } from 'vuex';

const mapRejectReworkMixin = {
	methods: {
		...mapMutations(['openLoaderDialog', 'closeLoaderDialog']),
		...mapActions('fileExtraction', ['updateFlagForSelectedUUID']),

		onDeletePythonScriptConvertableKeyButtonClick(data) {
			this.openLoaderDialog();
			this.updateFlagForSelectedUUID({
				uuid: data.uuid,
				$set: {},
				$unset: {
					isPythonScriptConvertable: true,
				},
			}).then(data => {
				if (!data.ok) {
					this.openSnackbar({
						text:
							'Failed to Remove Python Script Convertable key the selected file, Please try again',
					});
				}

				this.closeLoaderDialog();
			});
		},
	},
};

export default mapRejectReworkMixin;
